import { render, staticRenderFns } from "./SaleBase.vue?vue&type=template&id=1dc0ba82&scoped=true"
import script from "./SaleBase.vue?vue&type=script&lang=js"
export * from "./SaleBase.vue?vue&type=script&lang=js"
import style0 from "./SaleBase.vue?vue&type=style&index=0&id=1dc0ba82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0ba82",
  null
  
)

export default component.exports